import React from 'react';
import { Radio } from 'antd';
import { NamePath } from 'antd/lib/form/interface';
import { I18n } from '@aws-amplify/core';

import { Hand1 } from '@/assets/svg/human_body/hand-1';
import { Hand2 } from '@/assets/svg/human_body/hand-2';
import { Hand3 } from '@/assets/svg/human_body/hand-3';
import { Hand4 } from '@/assets/svg/human_body/hand-4';
import { Hand5 } from '@/assets/svg/human_body/hand-5';
import { Arm1 } from '@/assets/svg/human_body/arm-1';
import { useToggleableRadio } from '@/components/views/Report/KimLhc/hooks';
import { WORK_CONDITION_OPTIONS } from '@/components/views/Report/KimLhc/Constants';

import * as S from './styles';

interface HandsPositionFormItemProps {
	fieldName: NamePath;
}

const HANDS_POSITION_IMAGE_CONFIG = [
	{ svg: Hand1 },
	{ svg: Hand2 },
	{ svg: Hand3 },
	{ svg: Hand4 },
	{ svg: Arm1 },
	{ svg: Hand5 }
];

export function HandsPositionFormItem({ fieldName }: Readonly<HandsPositionFormItemProps>): JSX.Element {
	const handleRadioClick = useToggleableRadio(fieldName);

	return (
		<>
			<S.HandsPositionGrid>
				{HANDS_POSITION_IMAGE_CONFIG.map((config, idx) => {
					const SvgComponent = config.svg;

					return (
						<S.HandsPositionImageWrapper key={idx}>
							<SvgComponent style={{ width: '100%', height: 'auto' }} />
						</S.HandsPositionImageWrapper>
					);
				})}
			</S.HandsPositionGrid>

			<S.FormItemRow name={fieldName} style={{ marginTop: '16px' }}>
				<Radio.Group>
					<S.RadioOptionsContainer>
						{WORK_CONDITION_OPTIONS.hands_position.map((option) => (
							<Radio
								key={option.value}
								value={option.value}
								onClick={() => handleRadioClick(option.value)}
							>
								{I18n.get(option.labelKey)}
							</Radio>
						))}
					</S.RadioOptionsContainer>
				</Radio.Group>
			</S.FormItemRow>
		</>
	);
}
